import { useAccessToken } from '@jotta/auth-client/useAuthStatus'
import type { useQuery } from '@connectrpc/connect-query'
import { getLinks } from '@jotta/grpc-connect-openapi/wopiQuery'
import { publicTransport } from '@jotta/grpc-connect-client/transport'
import type { PathItemObject } from '@jotta/types/Files'
import { useLocale } from '@jotta/i18n'
import type {
  GetLinksRequest,
  GetLinksResponse,
  WopiActionType,
} from '@jotta/grpc-connect-openapi/wopi'
import { createConnectQuery } from '@jotta/grpc-connect-client/createConnectQuery'

export const getLinksQuery = createConnectQuery(getLinks)

export function useWopiLinks(
  item: PathItemObject,
  actionType: WopiActionType,
  options?: Parameters<typeof useQuery<GetLinksRequest, GetLinksResponse>>[2],
) {
  const locale = useLocale()
  const current_origin = location.origin.replace(
    'http://localhost:3300',
    'https://www.jottacloud.com',
  )
  const current_uri = `${current_origin}${location.pathname}`
  const folder_uri = current_uri.substring(0, current_uri.lastIndexOf('/'))

  const accessToken = useAccessToken()
  const token = item.accessTokenOverride || accessToken

  return getLinksQuery({
    variables: {
      actionType: actionType,
      path: item.path,
      language: locale,
      downloadLink: folder_uri,
      editLink: `${current_uri}?action=edit`,
      viewLink: `${current_uri}?action=view`,
      folderLink: folder_uri,
      closeLink: folder_uri,
    },
    transport: publicTransport,
    callOptions: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    ...options,
  })
}
